export default {"src":"/_next/static/media/background.426039f1.svg","height":475,"width":1920};